import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const client = axios.create({ baseURL: API });

/**
 * Storage del token JWT.
 * NOTA: usiamo `sessionStorage` (non localStorage) per due motivi:
 *  1. Il token muore alla chiusura del tab → obbliga il re-login se
 *     l'operatore chiude la finestra (in linea con "password sempre
 *     scritta dall'operatore").
 *  2. La password NON viene mai salvata (né sessionStorage né altrove).
 *     Solo il token JWT firmato viene conservato per la durata della
 *     sessione.
 */
const TOKEN_KEY = "pgi.auth.token";

export const getToken = () => {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
};

export const clearToken = () => setToken(null);

// Attach Bearer token automaticamente.
client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Gestione 401 globale: pulisce il token e reindirizza al login.
// Il redirect avviene via evento custom, gestito dall'AuthProvider,
// per evitare dipendenze circolari con react-router.
let onUnauthorized = null;
export const registerUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

client.interceptors.response.use(
  (r) => r,
  (err) => {
    // Non intercettare il 401 sull'endpoint login (è un feedback normale
    // per credenziali errate).
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.includes("/auth/login")) {
      clearToken();
      onUnauthorized?.();
    }
    return Promise.reject(err);
  },
);

export const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};
